import { Check } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useTheme } from '@/contexts/ThemeContext'
import { THEME_METADATA } from '@/lib/themes'
import { cn } from '@/lib/utils'

// Seletor de tema por conta (Perfil > Aparencia). Clicar aplica o tema na
// hora (preview vivo via data-theme no <html>) e persiste no backend — o
// tema segue a conta em qualquer dispositivo.
export function AppearanceSection() {
  const { theme, setTheme } = useTheme()

  return (
    <Card>
      <CardHeader>
        <CardTitle>Aparência</CardTitle>
        <CardDescription>
          Escolha o tema da plataforma. Ele segue a sua conta em qualquer dispositivo.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div role="radiogroup" aria-label="Tema da plataforma" className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {THEME_METADATA.map(({ value, label, tag, preview }) => {
            const selected = theme === value
            return (
              <button
                key={value}
                type="button"
                role="radio"
                aria-checked={selected}
                onClick={() => setTheme(value)}
                className={cn(
                  'relative flex flex-col gap-2 rounded-lg border p-3 text-left transition-all',
                  'hover:border-[var(--border-focus)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[var(--focus-ring)]',
                  selected
                    ? 'border-[var(--border-focus)] ring-4 ring-[var(--focus-ring)]'
                    : 'border-border'
                )}
              >
                {/* mini-swatch: hero + brand + accent do proprio tema */}
                <span className="flex h-8 w-full overflow-hidden rounded-md border border-border">
                  <span className="flex-[2]" style={{ backgroundColor: preview.hero }} />
                  <span className="flex-1" style={{ backgroundColor: preview.brand }} />
                  <span className="flex-1" style={{ backgroundColor: preview.accent }} />
                </span>
                <span className="flex items-center justify-between gap-2">
                  <span className="min-w-0">
                    <span className="block text-sm font-semibold">{label}</span>
                    <span className="block truncate text-xs text-muted-foreground">{tag}</span>
                  </span>
                  {selected && (
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground">
                      <Check className="h-3.5 w-3.5" />
                    </span>
                  )}
                </span>
              </button>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
}
